import type React from 'react';
import {
  LayoutDashboard,
  Building,
  BarChart3,
  Network,
  Shield,
  Users,
  Server,
  Radio,
  Settings,
  FileText,
  CreditCard,
  ScrollText,
  Gauge,
  Layers,
  LifeBuoy,
  HardDrive,
  Zap,
  FlaskConical,
  BrainCircuit,
  Puzzle,
  Phone,
  Activity,
  Workflow,
  Database,
  Tags
} from 'lucide-react';

export interface NavItem {
  name: string;
  href: string;
  icon: React.ElementType;
  description?: string;
}

export interface NavGroup {
  name: string;
  icon: React.ElementType;
  items: NavItem[];
}

export const navGroups: NavGroup[] = [
  {
    name: 'Overview',
    icon: LayoutDashboard,
    items: [
      { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, description: 'Panoramica cross-tenant' },
      { name: 'SIP Cluster', href: '/sip-cluster', icon: Radio, description: 'NOC unificato: topologia, signaling, media, trunks, extensions, system, queues, dialplan, ops' },
      { name: 'System Health', href: '/system', icon: Activity, description: 'Monitoraggio servizi' },
      { name: 'Code BullMQ', href: '/queues', icon: Layers, description: 'Monitoraggio code job' },
      { name: 'Mappa Infra', href: '/infra-map', icon: Network, description: 'Topologia cluster + export PDF/JSON' },
    ]
  },
  {
    name: 'Operations',
    icon: Building,
    items: [
      { name: 'Tenants', href: '/tenants', icon: Building, description: 'Gestione tenant' },
      { name: 'Stores', href: '/stores', icon: Building, description: 'Punti vendita' },
      { name: 'Companies', href: '/companies', icon: FileText, description: 'Ragioni sociali cross-tenant' },
      { name: 'Utenti tenant', href: '/users-tenant', icon: Users, description: 'Utenti applicativi cross-tenant' },
      { name: 'Admin master', href: '/users-master', icon: Users, description: 'Utenti, ruoli e permessi del piano master' },
      { name: 'Canali insegna', href: '/retail-brand-channels', icon: Tags, description: 'CRUD canali di vendita per insegna (catalogo globale)' },
      { name: 'Extensions', href: '/extensions', icon: Phone, description: 'Interni VoIP' },
      { name: 'Trunks', href: '/trunks', icon: Network, description: 'Trunk SIP' },
    ]
  },
  {
    name: 'Analytics',
    icon: BarChart3,
    items: [
      { name: 'Analytics', href: '/analytics', icon: BarChart3, description: 'Report e statistiche' },
      { name: 'RAG Quality', href: '/rag-quality', icon: BrainCircuit, description: 'Qualità retrieval RAG (recall, MRR, latenze)' },
      { name: 'Audit Log', href: '/audit-log', icon: ScrollText, description: 'Log attività' },
    ]
  },
  {
    name: 'Security',
    icon: Shield,
    items: [
      { name: 'Security Center', href: '/security', icon: Shield, description: 'Dashboard sicurezza' },
      { name: 'Network', href: '/network-monitoring', icon: Network, description: 'Monitoraggio rete' },
      { name: 'Rate Limits', href: '/rate-limits', icon: Gauge, description: 'Limiti richieste' },
    ]
  },
  {
    name: 'Config',
    icon: Settings,
    items: [
      { name: 'Templates', href: '/templates', icon: FileText, description: 'Template configurazioni' },
      { name: 'Public Context', href: '/public-context', icon: Workflow, description: 'Dialplan pubblico' },
      { name: 'Gestione DB', href: '/database', icon: Server, description: 'Database PostgreSQL' },
      { name: 'DB Studio', href: '/db-studio', icon: Database, description: 'CloudBeaver: client DBA grafico cross-tenant' },
      { name: 'Storage R2', href: '/storage', icon: HardDrive, description: 'Storage cloud e quote tenant' },
      { name: 'Billing', href: '/billing', icon: CreditCard, description: 'Fatturazione' },
      { name: 'Quote AI', href: '/ai-quotas', icon: Zap, description: 'Limiti consumo AI per tenant' },
      { name: 'Modelli AI', href: '/ai-models', icon: BrainCircuit, description: 'Modelli AI: Piattaforma, Custom' },
      { name: 'Integrazioni', href: '/integrations', icon: Puzzle, description: 'Integrazioni piattaforma (HERE Maps, ecc.)' },
    ]
  },
  {
    name: 'Observability',
    icon: Activity,
    items: [
      { name: 'Dashboards', href: '/observability', icon: Activity, description: 'Metriche cluster Grafana + error tracking' },
    ]
  },
  {
    name: 'Support',
    icon: LifeBuoy,
    items: [
      { name: 'Gestione Ticket', href: '/tickets', icon: LifeBuoy, description: 'Kanban, analisi e SLA' },
      { name: 'Test & Verify', href: '/test-verify', icon: FlaskConical, description: 'Test automatizzati sistema' },
    ]
  }
];
